import { cancelDeletion, getDeletion, requestDeletion } from "./endpoints";

export {
  ACCOUNT_DELETED_SIGN_IN_ERROR,
  DELETION_GRACE_DAYS,
  DELETION_SIGN_IN_WINDOW_MINUTES,
  service,
} from "./endpoints";
export {
  AccountDeletion,
  AccountDeletionResponse,
  DeletionTiming,
  RequestAccountDeletionBody,
} from "./schemas";

export const contract = {
  deletion: {
    get: getDeletion,
    create: requestDeletion,
    delete: cancelDeletion,
  },
} as const;
